// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Skúste to znova s použitím napríklad takéhoto dátumu dokončenia: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Skupina',
  chart_labelSeries: () => 'Séria',
  chart_labelValue: () => 'Hodnota',
  checkboxSet_requiredMessageDetail: () => 'Povinné',
  checkbox_requiredMessageDetail: () => 'Povinné',
  close: () => 'Zavrieť',
  collection_noData: () => 'Žiadne dáta na zobrazenie.',
  collection_selectAllRows: () => 'Vybrať všetky riadky',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Vybrať riadok ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Nie je možné triediť',
  collection_sortEnabled: () => 'Je možné triediť',
  confirmation: () => 'Potvrdenie',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' z ' + p['totalCount'],
  dataVisualization_noData: () => 'Žiadne dáta na zobrazenie',
  dataVisualization_stateSelected: () => 'Vybrané',
  dataVisualization_stateUnselected: () => 'Nevybrané',
  error: () => 'Chyba',
  expandableList_expandCollapseInstructionText: () =>
    'Na rozbalenie a zbalenie použite klávesy so šípkami',
  expandableList_groupCollapse: () => 'Zbalené',
  expandableList_groupExpand: () => 'Rozbalené',
  filePicker_addFiles: () => 'Pridať súbory',
  filePicker_dropzonePrimaryText: () => 'Presunutie myšou',
  filePicker_dropzoneSecondaryText: () => 'Vyberte súbor alebo sem presuňte nejaký súbor',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Vyberte súbory alebo sem presuňte nejaké súbory',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Súbory typu ' + p['fileTypes'] + ' nie je možné nahrať',
  filePicker_singleFileUploadError: () => 'Súbory nahrávajte po jednom',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Súbory typu ' + p['fileType'] + ' nie je možné nahrať',
  filePicker_unknownFileTypeUploadError: () => 'neznáme',
  formControl_clear: () => 'Vymazať',
  formControl_day: () => 'Deň',
  formControl_helpAvailable: () => 'K dispozícii je pomoc',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dosiahli ste limit ' +
    ((
      {
        one: '1 znaku',
        few: new Intl.NumberFormat('sk').format(p['CHARACTER_LIMIT']) + ' znakov',
        many: new Intl.NumberFormat('sk').format(p['CHARACTER_LIMIT']) + ' znaku'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('sk').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('sk').format(p['CHARACTER_LIMIT']) + ' znakov') +
    '.',
  formControl_loading: () => 'Zavádza sa',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximálna dĺžka ' + p['MAX_LENGTH'] + ' bola prekročená.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Počet zostávajúcich znakov: ' + p['CHARACTER_COUNT'] + '.',
  formControl_month: () => 'Mesiac',
  formControl_readOnly: () => 'Len na čítanie',
  formControl_requiredMessageDetail: () => 'Zadajte hodnotu.',
  formControl_year: () => 'Rok',
  gantt_labelDate: () => 'Dátum',
  gantt_labelEnd: () => 'Koniec',
  gantt_labelLabel: () => 'Návesť',
  gantt_labelRow: () => 'Riadok',
  gantt_labelStart: () => 'Začiatok',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nenašla sa žiadna zodpovedajúca sekcia.',
  indexer_keyboardInstructionText: () => 'Stlačte kláves Enter a vyberte hodnotu.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Medzi ' + p['FROM_SECTION'] + ' a ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvakrát ťuknite a podržte na zadanie režimu gest, potom posunutím nahor alebo nadol upravte hodnotu.',
  info: () => 'Informácie',
  inputDateMask_date_cleared: () => 'Dátum vymazaný',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prázdne',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'rrrr',
  inputNumber_converterParseError: () => 'Zadajte číslo.',
  inputNumber_decrease: () => 'Znížiť',
  inputNumber_increase: () => 'Zvýšiť',
  inputPassword_hidden: () => 'Skryté heslo',
  inputPassword_hide: () => 'Skryť heslo',
  inputPassword_show: () => 'Zobraziť heslo',
  list_suggestion: () => 'Návrh',
  messageToast_allMessagesClosed: () => 'Všetky vyskakovacie oznámenia sú zavreté.',
  message_close: () => 'Zavrieť',
  message_confirmation: () => 'Úspešné',
  message_error: () => 'Chyba',
  message_info: () => 'Informácie',
  message_navigationFromMessagesRegion: () =>
    'Vstupujete do oblasti správ. Stlačte kláves F6, ak sa chcete vrátiť na predchádzajúci aktívny prvok.',
  message_navigationToMessagesRegion: () =>
    'Oblasť správ obsahuje nové správy. Stlačením klávesu F6 prejdete do oblasti s najnovšou správou.',
  message_warning: () => 'Upozornenie',
  noData_message: () => 'Neexistujú položky na zobrazenie',
  overflowItemLabel: () => 'Ďalšie karty',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Prebieha',
  radio_helpForRadio: () => 'Pomoc pre prepínač',
  radio_requiredMessageDetail: () => 'Vyberte hodnotu.',
  selectMultiple_apply: () => 'Použiť',
  selectMultiple_back: () => 'Späť',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Na odobratie vybranej hodnoty stlačte klávesy Backspace alebo Delete.',
  selectMultiple_selectedValues: () => 'Vybrané hodnoty',
  selectMultiple_showSelectedValues: () => 'Zobraziť len vybrané hodnoty.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Počet vybraných hodnôt: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Pridať do zoznamu',
  select_addToListAvailable: () => 'K dispozícii je pridanie do zoznamu',
  select_moreSearchOptions: () => 'Ďalšie voľby vyhľadávania',
  select_moreSearchOptionsAvailable: () => 'K dispozícii sú ďalšie voľby vyhľadávania',
  select_noMatchesFound: () => 'Nenašli sa žiadne zhody.',
  select_oneMatchFound: () => 'Našla sa jedna zodpovedajúca hodnota',
  select_requiredMessageDetail: () => 'Vyberte hodnotu.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Nájdené zhody: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Nájdené zhody: ' + p['TOTAL_SIZE'] + ' alebo viac',
  selector_selected: () => 'Políčko je začiarknuté',
  selector_unselected: () => 'Políčko nie je začiarknuté',
  tabBarNavigationList_removeCueText: () => 'Možno odobrať',
  timeComponent_tooltipZoomIn: () => 'Priblížiť',
  timeComponent_tooltipZoomOut: () => 'Oddialiť',
  train_current: () => 'Aktuálny',
  train_message_type: () => 'Typ hlásenia',
  train_not_visited: () => 'Nenavštívený',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Krok ' + p['currentStep'] + ' z ' + p['numberOfSteps'],
  train_visited: () => 'Navštívený',
  userAssistance_learnMore: () => 'Ďalšie informácie',
  userAssistance_required: () => 'Povinné',
  viz_drillable: () => 'Možno použiť funkciu prechodu',
  warn: () => 'Upozornenie'
};
export default bundle;
